import React from 'react';
import { Play, RotateCcw, Info, Menu } from 'lucide-react';

interface HeaderProps {
  isPlaying: boolean;
  setIsPlaying: (playing: boolean) => void;
  reset: () => void;
  onAboutClick: () => void;
  onToggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({
  isPlaying,
  setIsPlaying,
  reset,
  onAboutClick,
  onToggleSidebar,
}) => {
  return (
    <header className="flex items-center justify-between border-b border-zinc-800/50 bg-zinc-900/20 px-4 py-4 backdrop-blur-md md:px-8 md:py-6">
      <div className="flex items-center gap-3 md:gap-4">
        <button
          onClick={onToggleSidebar}
          className="rounded-lg bg-zinc-800 p-2 text-zinc-400 transition-all hover:text-white md:hidden"
          aria-label="Toggle Menu"
        >
          <Menu className="h-5 w-5" />
        </button>

        <div className="h-10 w-10 overflow-hidden rounded-xl shadow-[0_0_20px_rgba(16,185,129,0.3)]">
          <img
            src="/images/logo.webp"
            alt="Shifting Arithmetic Logo"
            className="h-full w-full object-cover"
          />
        </div>
        <div className="hidden md:block">
          <h1 className="text-lg font-bold tracking-tight text-white md:text-xl">
            Shifting Arithmetic
          </h1>
          <p className="hidden font-mono text-xs tracking-widest text-zinc-500 uppercase md:block">
            Triangular Multiplication Playground
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 md:gap-3">
        <button
          onClick={() => setIsPlaying(!isPlaying)}
          className={`flex items-center gap-2 rounded-lg px-4 py-2 font-medium transition-all ${
            isPlaying
              ? 'cursor-not-allowed bg-zinc-800 text-zinc-400'
              : 'bg-emerald-500 text-black shadow-lg shadow-emerald-500/20 hover:bg-emerald-400'
          }`}
        >
          <Play className="h-4 w-4 fill-current" />
          <span className="hidden sm:inline">
            {isPlaying ? 'Playing...' : 'Animate Growth'}
          </span>
        </button>
        <button
          onClick={reset}
          className="rounded-lg bg-zinc-800 p-2 text-zinc-400 transition-all hover:bg-zinc-700 hover:text-white"
        >
          <RotateCcw className="h-5 w-5" />
        </button>
        <button
          onClick={onAboutClick}
          className="rounded-lg bg-zinc-800 p-2 text-zinc-400 transition-all hover:bg-zinc-700 hover:text-white"
        >
          <Info className="h-5 w-5" />
        </button>
      </div>
    </header>
  );
};

export default Header;
